import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ToasterProvider } from "./contexts/ToasterContext";
import { ClientStatusProvider } from "./contexts/ClientStatusContext";
import { AuthProvider } from "./contexts/AuthContext";
// BYPASS AUTH: authInterceptor no longer needed - all auth checks removed
// import "./utils/authInterceptor";
import LoginPage from "./pages/auth/login/LoginPage";
import ForgotPassword from "./pages/auth/forgot/ForgotPassword";
//import VerifyOtp from "./pages/auth/otp/VerifyOtp";
import SignupPage from "./pages/auth/signup/SignupPage";
//import CreateNewPassword from "./pages/auth/password/CreateNewPassword";
import DashboardPage from "./pages/dashboard/DashboardPage";
import RepositoryOnboardingPage from "./pages/repositories/OnboardingPage";
import IntegrationPage from "./pages/integrations/IntegrationPage";
import IntegrationTypePage from "./pages/integrations/IntegrationTypePage";
import SettingsPage from "./pages/settings/SettingsPage";
import ManageScansPage from "./pages/manage-scans/ManageScansPage";
// import ListPage from "./pages/repositories/ListPage";
import GenericBlastRadiusPage from "./components/BlastRadius/GenericBlastRadiusPage";
import SecretPage from "./pages/repositories/SecretPage";
// import IntelPage from "./pages/intel/IntelPage";
import PublicRoute from "./components/Auth/PublicRoute";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import OnboardingRoute from "./components/Auth/OnboardingRoute";
import OnboardingPage from "./pages/onboarding/OnboardingPage";
import SubscriptionExpiredPage from "./pages/subscription/SubscriptionExpiredPage";
import Layout from "./components/Layout/Layout";
import AuthCallback from "./components/wait/AuthCallback";
import Risk from "./pages/dashboard/RiskPage";
import TokenVisual from "./pages/blast-radius/TokenVisual";
import S3OnboardingPage from "./pages/integrations/S3Page/S3OnboardingPage";
import SlackPage from "./pages/integrations/Slack/SlackPage";
import SlackChannelFindingsPage from "./pages/integrations/Slack/SlackChannelFindingsPage";
import TeamsOnboardingPage from "./pages/integrations/TeamsOnboardingPage";
import TeamsChannelOnboardingPage from "./pages/integrations/TeamsPage/TeamsChannelOnboardingPage";
import IntegrationListPage from "./pages/integrations/IntegrationListPage";
import CloudIAMResults from "./pages/integrations/CloudIAMResults";
import ActiveDirectoryPage from "./pages/identity-management/ActiveDirectoryPage";
import ActiveDirectoryResultsPage from "./pages/identity-management/ActiveDirectoryResultsPage";
// import GoogleCloudStoragePage from "./pages/integrations/GoogleCloudStorage";
// import AzureBlobStoragePage from "./pages/integrations/AzureBlob";

function App() {
  return (
    <ToasterProvider>
      <AuthProvider>
        <ClientStatusProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              <Route element={<PublicRoute />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                {/* <Route path="/verify-otp" element={<VerifyOtp />} /> */}
                {/* <Route
                path="/create-new-password"
                element={<CreateNewPassword />}
              /> */}
                <Route path="/auth" element={<AuthCallback />} />
              </Route>
              <Route path="/onboarding" element={<OnboardingRoute />}>
                <Route index element={<OnboardingPage />} />
              </Route>
              <Route
                path="/subscription-expired"
                element={<SubscriptionExpiredPage />}
              />
            
           
                <Route element={<Layout />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  {/* <Route path="/repositories" element={<RepositoriesPage />} /> */}
                  <Route
                    path="/integration/github/onboarding"
                    element={<RepositoryOnboardingPage />}
                  />
                  {/* <Route path="/repositories/:repoId" element={<ListPage />} /> */}
                  <Route
                    path="/integration/github/:repoId/blast-radius/:insightId"
                    element={<GenericBlastRadiusPage type="repo" />}
                  />
                  <Route
                    path="/integration/github/:repoId/secrets/:secretId"
                    element={<TokenVisual />}
                  />
                  {/* Identity Management (formerly Integrations / Marketplace) */}
                  <Route
                    path="/identity-management"
                    element={<IntegrationPage />}
                  />
                  <Route
                    path="/identity-management/active-directory"
                    element={<ActiveDirectoryPage />}
                  />
                  {/* Active Directory Results Route */}
                  <Route
                    path="/identity-management/active-directory/:id"
                    element={<ActiveDirectoryResultsPage />}
                  />
                  {/* Backwards-compatible redirect from old /integration root */}
                  <Route
                    path="/integration"
                    element={
                      <Navigate to="/identity-management" replace />
                    }
                  />

                  {/* Active Directory Integration Routes */}
                  <Route
                    path="/integration/active-directory"
                    element={<ActiveDirectoryPage />}
                  />
                  <Route
                    path="/integration/active-directory/:id"
                    element={<ActiveDirectoryResultsPage />}
                  />

                  {/* Dynamic Integration Routes */}
                  <Route
                    path="/integration/:type"
                    element={<IntegrationTypePage />}
                  />
                  <Route
                    path="/integration/:type/:id"
                    element={<IntegrationListPage />}
                  />

                  {/* IAM Results Routes (Identity Management) */}
                  <Route
                    path="/identity-management/iam/:type"
                    element={<CloudIAMResults />}
                  />
                  <Route
                    path="/identity-management/iam/:provider/:scanId"
                    element={<CloudIAMResults />}
                  />

                  {/* Legacy specific integration routes (for backward compatibility) */}
                  {/* <Route path="/integration/aws" element={<IntegrationAWSPage />} />
                <Route path="/integration/gcp" element={<IntegrationGCPPage />} />
                <Route path="/integration/azure" element={<IntegrationAzurePage />} />
                <Route path="/integration/github" element={<IntegrationGithubPage />} /> */}
                  <Route path="/integration/slack" element={<SlackPage />} />
                  <Route
                    path="/integration/slack/:channelId"
                    element={<SlackChannelFindingsPage />}
                  />

                  {/* Legacy S3 routes */}
                  <Route
                    path="/integration/s3/onboarding"
                    element={<S3OnboardingPage />}
                  />
                  
                  {/* Teams routes */}
                  <Route
                    path="/integration/teams/onboarding"
                    element={<TeamsOnboardingPage />}
                  />
                  <Route
                    path="/integration/teams/channel-onboarding"
                    element={<TeamsChannelOnboardingPage />}
                  />
                  <Route
                    path="/integration/slack/channels/:channelId"
                    element={<SlackChannelFindingsPage />}
                  />
                  <Route
                    path="/integration/s3/:bucketId/blast-radius/:findingId"
                    element={<GenericBlastRadiusPage type="s3" />}
                  />

                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/manage-scans" element={<ManageScansPage />} />
                  {/* <Route path="/repositories/list" element={<ListPage />} /> */}
                  <Route path="/repositories/secret" element={<SecretPage />} />
                  <Route path="/risk" element={<Risk />} />
                  {/* 
                <Route path="/intel" element={<IntelPage />} />
                */}
                </Route>
              
            </Routes>
          </BrowserRouter>
        </ClientStatusProvider>
      </AuthProvider>
    </ToasterProvider>
  );
}

export default App;
